import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Nsba_horse } from '../models/nsba_horse';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class NsbaHorseSearchService {

	constructor(private http: HttpClient) { }

	getByTerm(term: string): Promise<Nsba_horse[]> {
		return this.getWithRest("term/" + term);
	}

	private getWithRest(rest_url: string) : Promise<Nsba_horse[]> {
	  	return new Promise((resolve, reject) => {

	  		return this.http.get(AppSettings.API_ENDPOINT + 'nsba_horse_search/' + rest_url).subscribe((response:any) => {
				if(response.type == 'search_results' && response.data){
					resolve(response.data);
				} else {
					reject(response);
				}

			},
				error_response => {
		      		if(error_response instanceof HttpErrorResponse){
		      			reject(error_response.error);
		      		}
		      		reject(error_response);
				});


	  	});
	  }

}
